// extracted by mini-css-extract-plugin
export default {"navWrapper":"NavAuth_navWrapper__VBxmG","loaderWrapper":"NavAuth_loaderWrapper__dRzp+"};